import { Colors, Storage, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
let contentPreferences = [];
export default class Subtitles extends Lightning.Component {
  static _template() {
    return {
      h: 50,
      Column: {
        h: 60,
        flex: { direction: 'row', alignItems: 'center' },
        Wrapper: {
          w: 40,
          h: 85,
          flex: { direction: 'row', alignItems: 'center' },
          Icon: {},
        },
        Language: { y: 5 },
      },
      LanguageBorder: {
        collision: true,
        texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#000000').get(), false),
      },
    };
  }
  set movieId(val) {
    return (this._movieId = val);
  }
  set subtitle(val) {
    return (this._subtitle = val);
  }

  set index(val) {
    this._index = val;
  }

  get subtitle() {
    return this._subtitle;
  }
  get _Language() {
    return this.tag('Language');
  }
  get _LanguageBorder() {
    return this.tag('LanguageBorder');
  }
  get _Icon() {
    return this.tag('Icon');
  }
  _firstEnable() {
    let contentPreferences = Storage.get('content_preferences');
    let profileId = Storage.get('profileId');
    let movieId = this._movieId;
    let movieConfiguration = contentPreferences?.find(
      (preference) => preference.profileId === profileId && preference.movieId === movieId
    );
    this._Language.patch({
      x: 40,
      text: {
        text: this._subtitle.languageName,
        fontSize: 36,
        fontFace: 'OpenSans-Regular',
      },
      color: Colors('#D6D6D6').get(),
    });
  }
  _focus() {
    super._focus();
    if (!this._isSelected) {
      this._Language.patch({
        color: Colors('#FAFAFA').get(),
      });
    }
    this._LanguageBorder.patch({
      texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#02AC25').get(), false),
    });
  }

  _selectSubtitleButton() {
    this._Icon.patch({
      x: 30,
      texture: lng.Tools.getSvgTexture(Utils.asset('images/settings-icons/checkmark.svg'), 30, 30),
    });
    this._Language.patch({
      x: 40,
      text: {
        text: this._subtitle.languageName,
        fontSize: 36,
        fontFace: 'OpenSans-Regular',
      },
      color: Colors('#FAFAFA').get(),
    });
    this._isSelected = true;
    this.parent._selectedLanguage = this;
    let contentPreferences = Storage.get('content_preferences') || [];
    let userInfo = contentPreferences.find(
      (preference) =>
        preference.profileId === Storage.get('profileId') && preference.movieId === this._movieId
    );
    let preference = {
      profileId: Storage.get('profileId'),
      movieId: this._movieId,
      audio: userInfo ? userInfo.audio : 'en-US', // Set to 'en-US' if audio is not found in userInfo
      subtitle: this._subtitle.lng, // Use this._subtitle.lng as the subtitle preference
    };
    let index = contentPreferences.findIndex(
      (pref) => pref.profileId === Storage.get('profileId') && pref.movieId === this._movieId
    );
    if (index > -1) {
      contentPreferences.splice(index, 1);
    }
    contentPreferences.push(preference);
    Storage.set('content_preferences', contentPreferences);
  }
  _unfocus() {
    super._unfocus();
    if (!this._isSelected) {
      this._Language.patch({
        color: Colors('#D6D6D6').get(),
      });
    }
    this._LanguageBorder.patch({
      texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#000000').get(), false),
    });
  }
  _handleEnter() {
    let contentPreferences = Storage.get('content_preferences') || [];
    let userInfo = contentPreferences.find(
      (preference) =>
        preference.profileId === Storage.get('profileId') && preference.movieId === this._movieId
    );
    let preference = {
      profileId: Storage.get('profileId'),
      movieId: this._movieId,
      audio: userInfo ? userInfo.audio : 'en-US', // Set to 'en-US' if audio is not found in userInfo
      subtitle: this._subtitle.lng, // Use this._subtitle.lng as the subtitle preference
    };
    let index = contentPreferences.findIndex(
      (pref) => pref.profileId === Storage.get('profileId') && pref.movieId === this._movieId
    );
    if (index > -1) {
      contentPreferences.splice(index, 1);
    }
    contentPreferences.push(preference);
    Storage.set('content_preferences', contentPreferences);
    if (this.parent._selectedLanguage != this) {
      if (this.parent._selectedLanguage) {
        this.parent._selectedLanguage._Icon.patch({
          texture: null,
        });
        this.parent._selectedLanguage._Language.patch({
          text: { textColor: Colors('#D6D6D6').get() }, // set color to original when deselected
        });
        this.parent._selectedLanguage._isSelected = false;
      }
      this._Icon.patch({
        x: 30,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('images/settings-icons/checkmark.svg'),
          30,
          30
        ),
      });
      this._Language.patch({
        text: { textColor: Colors('#FAFAFA').get() }, // set color to red when selected
      });
      this._isSelected = true;
      this.parent._selectedLanguage = this;
    }
  }

  // Magic Remote

  _handleHover() {
    this.fireAncestors('$setState', 'Subtitles');
    this.fireAncestors('$setSubtitleIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
